module.exports = __webpack_public_path__ + "img/report1-1.859f4552.jpg";